// rename react-autosuggest classes, see:
// https://github.com/moroshko/react-autosuggest#theme-prop
import atomTheme from "./atom-theme";

// make atom theme the default theme
export default atomTheme;
